import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Avatar } from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import IconButton from "@material-ui/core/IconButton";
import Loading from "../Shared/Loading";
import Typography from "@material-ui/core/Typography";

import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { USERS_PER_PAGE } from "../../../types/micellinous-constants";
import { MatxTable, MatxTableCell, MatxTableHead } from "../Shared";
import { Link } from "react-router-dom";

import { UserTable } from "@thequantumhub/iam-package";

const headCells = [
  {
    label: "Sr.",
    align: "left",
    id: "sr",
  },
  {
    label: "User Name",
    align: "left",
    id: "userName",
  },

  {
    label: "User Group",
    align: "left",
    id: "userGroup",
  },
  {
    label: "Action",
    align: "left",
    id: "userAction",
  },
];

const SearchTable = ({
  styles,
  headCells,
  loadingUsers,
  searchedUsers,
  searchQuery,
  handleOpenDeleteUserDialog,
  userGroupId,
  setUserGroupId,
  userGroups,
  setUserGroups,
  handleUserClick,
  userGroupLoading,
  finalPageCount,
}) => {
  const [loading, setLoading] = useState(false);

  const usersPerPage = USERS_PER_PAGE;

  const [userPage, setUserPage] = React.useState(1);

  // this useEffect gets users when component initially renders

  const handlePageBack = () => {
    if (userPage != 1) {
      setUserPage(userPage - 1);
    }
  };

  const handlePageForward = () => {
    if (userPage * usersPerPage < searchedUsers.length) {
      setUserPage(userPage + 1);
    }
  };
  const handleClick = (id) => {
    // console.log(id);
  };

  useEffect(() => {
    setUserPage(1);
  }, [searchedUsers]);

  if (loading) {
    return <Loading />;
  }
  return (
    <>
      <UserTable
        styles={styles}
        headCells={headCells}
        loadingUsers={loadingUsers}
        users={searchedUsers}
        userPage={userPage}
        usersPerPage={usersPerPage}
        handleUserClick={handleUserClick}
        userGroupLoading={userGroupLoading}
        userGroups={userGroups}
        handleOpenDeleteUserDialog={handleOpenDeleteUserDialog}
        handlePageBack={handlePageBack}
        handlePageForward={handlePageForward}
        finalPageCount={finalPageCount}
      />
    </>
  );
};

export default SearchTable;
